'use client'

import './home.css'

import { Col, Container, Row } from 'react-bootstrap'

import LeftIcon from '@/assets/images/20Yearslogo.webp'
import RightIcon from '@/assets/images/brandlogo.svg'
import HeroBg from '@/assets/images/HeroBanner.webp'

function HeroBanner() {
  return (
    <section
      className="section heroBanner hero-banner-responsive py-md-5 py-4"
      style={{
        backgroundImage: `url(${HeroBg.src})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <Container>
        {/* Top logos */}
        <Row className="align-items-center hero-banner-logos py-md-3">
          <Col xs={5} md={4} className="text-start">
            <img src={LeftIcon.src} alt="20 Years Logo" className="hero-logo hero-logo-20years" />
          </Col>

          <Col xs={2} md={4} />

          <Col xs={5} md={4} className="text-end">
            <img
              src={RightIcon.src}
              alt="Alrajhi Bank Logo"
              className="hero-logo hero-logo-brand"
            />
          </Col>
        </Row>

        {/* Text content */}
        <Row>
          <Col xs={12} md={12}>
            <h1
              className="short-title text-white mt-4 mt-md-4 mb-1 mb-md-4 font30 font26"
              data-aos="zoom-in"
              data-aos-duration="1000"
            >
              Values-driven Islamic banking in Malaysia since 2006
            </h1>
            <p className="hero-banner-subtitle fs-22">Here for you</p>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default HeroBanner
